import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { InnoverseLogo } from '../ui/InnoverseLogo';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Products',
    path: '/products'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md border-b border-slate-200 py-3' : 'bg-transparent py-5'}`} data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="flex justify-between items-center" data-id="element-70">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group" data-id="element-71">
            <InnoverseLogo size={36} variant="dark" data-id="element-72" />
            <span className="font-bold text-slate-900 tracking-tight text-[36px] leading-none" data-id="element-73">
              Innoverse
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-74">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-navy-600 ${location.pathname === link.path ? 'text-navy-600' : 'text-slate-600'}`} data-id="element-75">
                {link.name}
              </Link>)}
            <Button variant="primary" size="sm" href="/contact" data-id="element-76">
              Request Demo
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-77">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-600 hover:text-navy-600 focus:outline-none" data-id="element-78">
              {isOpen ? <X size={24} data-id="element-79" /> : <Menu size={24} data-id="element-80" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav Panel */}
      <AnimatePresence data-id="element-81">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-slate-200 overflow-hidden" data-id="element-82">
            <div className="px-4 pt-2 pb-6 space-y-4" data-id="element-83">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`block text-base font-medium py-2 ${location.pathname === link.path ? 'text-navy-600' : 'text-slate-600'}`} data-id="element-84">
                  {link.name}
                </Link>)}
              <div className="pt-2" data-id="element-85">
                <Button variant="primary" fullWidth href="/contact" data-id="element-86">
                  Request Demo
                </Button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}